import { defineSlotRecipe } from '@chakra-ui/react';
import { alertAnatomy } from '@chakra-ui/react/anatomy';
import { getTokenValueOrString } from '../utils';

export type ThemeGenAlertConfig = {
  borderRadius: number;
};

export function generateAlertSlotRecipe(config?: ThemeGenAlertConfig) {
  return defineSlotRecipe({
    slots: alertAnatomy.keys(),
    base: {
      root: {
        borderRadius: getTokenValueOrString(config?.borderRadius, 'px')
      },
      title: {
        fontWeight: 'bold'
      }
    },
    variants: {
      size: {
        xs: {
          root: {
            gap: '1',
            px: '1',
            py: '1',
            textStyle: 'xs'
          },
          indicator: {
            textStyle: 'md'
          }
        }
      }
    }
  });
}
